// Author - Atul Pandey
// First Created - 26 Feb 2025
// Purpose - to define admin menu items
// Updated - 06 May 2025 - added orgAdminMenuItems
// Updated - 06 May 2025 - added userAdminMenuItems
// Updated - 11 May 2025 - added userAdminImprintMenuItems
// Updated - 26 Jun 2025 - added Habits
// Updated - 19 Aug 2025 - added Assessments
// Updated - 27 Apr 2026 - added OrganizationBUs
// Updated - 27 Apr 2026 - added Accounts
// Updated - 27 Apr 2026 - added AccountContactMaps
// Updated - 06 May 2026 - added userSchedulingPages
// Updated - 26 May 2026 - added sessionQNA
// Updated - 12 Jun 2026 - added orgTrailSessionCohort
// Updated - 26 Jun 2026 - added orgLeaderAdminMenuItems
// Updated - 19 Aug 2026 - added orgTrailSessionChallengeAssignments
// Updated - 04 Sep 2026 - added orgIntentionBoards
// Updated - 08 Sep 2026 - added orgIgniterMenuItems
// Updated - 07 Oct 2026 - added orgTrailSessionQNAAssignments
// Updated - 08 Oct 2026 - added sessionReferenceContents
// Updated - 08 Oct 2026 - added orgTrailSessionContentAssignments
// Updated - 14 Oct 2026 - added Trinity Meeting Board
// Updated - 29 Oct 2026 - Coach Evaluation Framework


const adminMenuItems = [

    { key: 'users', label: 'Users', subKeys: ['updateUser', 'deleteUser'] },
    { key: 'challengeHeads', label: 'Challenge Heads', subKeys: ['updateChallengeHead', 'deleteChallengeHead'] },
    { key: 'challenges', label: 'Challenges', subKeys: ['updateChallenge', 'deleteChallenge'] },

    // 29 Oct 2026 - Coach Evaluation Framework
    {
        key: 'evaluationFramework',
        label: 'Evaluation Framework',
        subKeys: [],
    },

    // 14 Oct 2026
    {
        key: 'trinityMeetings',
        label: 'Meeting Board',
        subKeys: [
            'createTrinityMeetings',
        ],
    },

    // 04 Sep 2026
    {
        key:
            'orgIntentionBoards',

        label:
            'Intention Boards',

        subKeys: [
            'updateOrgIntentionBoard',
            'deleteOrgIntentionBoard',
        ],
        },

    // 19 Aug 2026
    {
        key: 'orgTrailSessionChallengeAssignments', label: 'Session Challenge Assignments', subKeys: [
'updateOrgTrailSessionChallengeAssignment', 'deleteOrgTrailSessionChallengeAssignment',],
    },
    
    // 07 Oct 2026
    {
        key: 'orgTrailSessionQNAAssignments', label: 'Session QNA Assignments', subKeys: [
'updateOrgTrailSessionQNAAssignment', 'deleteOrgTrailSessionQNAAssignment',],
    },

    // 08 Oct 2026
    {
        key: 'sessionReferenceContents', label: 'Session Reference Contents', subKeys: [
'updateSessionReferenceContent', 'deleteSessionReferenceContent',],
    },

    // 08 Oct 2026
    {
        key: 'orgTrailSessionContentAssignments', label: 'Session Content Assignments', subKeys: [
'updateOrgTrailSessionContentAssignment', 'deleteOrgTrailSessionContentAssignment',],
    },


    { key: 'habits', label: 'Habits', subKeys: ['updateHabit', 'deleteHabit'] },// 26 Jun 2025
    { key: 'organizations', label: 'Organizations', subKeys: ['updateOrganization', 'deleteOrganization'] },
    { key: 'orgRoles', label: 'Org Roles', subKeys: ['updateOrgRole', 'deleteOrgRole'] },
    { key: 'orgTitles', label: 'Org Titles', subKeys: ['updateOrgTitle', 'deleteOrgTitle'] },

    // 06 May 2026
    { key: 'userSchedulingPages',label: 'SlotBoard Pages', subKeys: ['updateUserSchedulingPages',  'deleteUserSchedulingPages']},
    
    // 26 May 2026
    { key: 'sessionQNAs',label: 'Session Q&As', subKeys: ['updateSessionQNAs',  'deleteSessionQNAs']},
    
    { key: 'questionSets', label: 'Question Sets', subKeys: ['updateQuestionSet', 'deleteQuestionSet'] },
    { key: 'questionWithScores', label: 'Question With Scores', subKeys: ['updateQuestionWithScores', 'deleteQuestionWithScores'] },
    { key: 'sections', label: 'Sections', subKeys: ['updateSection', 'deleteSections'] },
    { key: 'assessments', label: 'Asessments', subKeys: ['updateAssessment', 'deleteAssessment'] }, // 19 Aug 2025
    
    { key: 'subsPacks', label: 'Subscription Packs', subKeys: ['updateSubsPack', 'deleteSubsPack'] },
    { key: 'orgSubscriptions', label: 'Org Subscriptions', subKeys: ['updateOrgSubscription', 'deleteOrgSubscription'] },

    { key: 'trails', label: 'Trails', subKeys: ['updateTrail', 'deleteTrail'] },
    { key: 'sessions', label: 'Sessions', subKeys: ['updateSession', 'deleteSession'] },

    // 12 Jun 2026
    { key: 'orgTrailSessionCohorts',label: 'Trail Cohorts', subKeys: ['updateOrgTrailSessionCohorts',  'deleteOrgTrailSessionCohorts']},


    
    { key: 'coachUserPads', label: 'Coach Pads', subKeys: ['updateCoachUserPad', 'deleteCoachUserPad'] },
    { key: 'sponsorUserPads', label: 'Sponsor Pads', subKeys: ['updateSponsorUserPad', 'deleteSponsorUserPad'] },
    { key: 'actionTypes', label: 'Action Types', subKeys: ['updateActionType', 'deleteActionType'] },
    { key: 'capabilitiesAdvisoryTypes', label: 'CapabilitiesAdvisory Types', subKeys: ['updateCapabilitiesAdvisoryType', 'deleteCapabilitiesAdvisoryType'] },
    { key: 'capabilitiesDomainTypes', label: 'CapabilitiesDomain Types', subKeys: ['updateCapabilitiesDomainType', 'deleteCapabilitiesDomainType'] },
    { key: 'capabilitiesFunctionTypes', label: 'CapabilitiesFunction Types', subKeys: ['updateCapabilitiesFunctionType', 'deleteCapabilitiesFunctionType'] },
    { key: 'capabilitiesIndustryTypes', label: 'CapabilitiesIndustry Types', subKeys: ['updateCapabilitiesIndustryType', 'deleteCapabilitiesIndustryType'] },
    { key: 'capabilitiesSalesFunctionAreaTypes', label: 'CapabilitiesSalesFunctionArea Types', subKeys: ['updateCapabilitiesSalesFunctionAreaType', 'deleteCapabilitiesSalesFunctionAreaType'] },
    { key: 'capabilitiesSalesTypes', label: 'CapabilitiesSales Types', subKeys: ['updateCapabilitiesSalesType', 'deleteCapabilitiesSalesType'] },
    { key: 'capabilitiesServiceFunctionAreaTypes', label: 'CapabilitiesServiceFunctionArea Types', subKeys: ['updateCapabilitiesServiceFunctionAreaType', 'deleteCapabilitiesServiceFunctionAreaType'] },
    { key: 'capabilitiesServiceTypes', label: 'CapabilitiesService Types', subKeys: ['updateCapabilitiesServiceType', 'deleteCapabilitiesServiceType'] },
    { key: 'capabilitiesSoftSkillFunctionAreaTypes', label: 'CapabilitiesSoftSkillFunctionArea Types', subKeys: ['updateCapabilitiesSoftSkillFunctionAreaType', 'deleteCapabilitiesSoftSkillFunctionAreaType'] },
    { key: 'capabilitiesSoftSkillTypes', label: 'CapabilitiesSoftSkill Types', subKeys: ['updateCapabilitiesSoftSkillType', 'deleteCapabilitiesSoftSkillType'] },
    { key: 'capabilitiesTechAreaTypes', label: 'CapabilitiesTechArea Types', subKeys: ['updateCapabilitiesTechAreaType', 'deleteCapabilitiesTechAreaType'] },
    { key: 'capabilitiesTechStackTypes', label: 'CapabilitiesTechStack Types', subKeys: ['updateCapabilitiesTechStackType', 'deleteCapabilitiesTechStackType'] },
    
    // { key: 'contacts', label: 'Contacts', subKeys: ['updateContact', 'deleteContact'] },
    // { key: 'contactOrganizations', label: 'ContactOrganizations', subKeys: ['updateContactOrganization', 'deleteContactOrganization'] },
    { key: 'contactOrganizationTypes', label: 'ContactOrganizationTypes', subKeys: ['updateContactOrganizationType', 'deleteContactOrganizationType'] },
    { key: 'contactTypes', label: 'Contact Types', subKeys: ['updateContactType', 'deleteContactType'] },
    { key: 'challengeTypes', label: 'Challenge Types', subKeys: ['updateChallengeType', 'deleteChallengeType'] },
    { key: 'contributionTypes', label: 'Contribution Types', subKeys: ['updateContributionType', 'deleteContributionType'] },
    { key: 'creationAreaTypes', label: 'CreationArea Types', subKeys: ['updateCreationAreaType', 'deleteCreationAreaType'] },
    { key: 'creationTypes', label: 'Creation Types', subKeys: ['updateCreationType', 'deleteCreationType'] },
    { key: 'gratitudeTypes', label: 'Gratitude Types', subKeys: ['updateGratitudeType', 'deleteGratitudeType'] },
    { key: 'goalTypes', label: 'Goal Types', subKeys: ['updateGoalType', 'deleteGoalType'] }, // 11 Aug 2025
   
    { key: 'impactTypes', label: 'Impact Types', subKeys: ['updateImpactType', 'deleteImpactType'] },
    { key: 'inspirationBeaconTypes', label: 'InspirationBeacon Types', subKeys: ['updateInspirationBeaconType', 'deleteInspirationBeaconType'] },
    { key: 'intentionTypes', label: 'Intention Types', subKeys: ['updateIntentionType', 'deleteIntentionType'] },
    { key: 'investigationTypes', label: 'Investigation Types', subKeys: ['updateInvestigationType', 'deleteInvestigationType'] },
    { key: 'legacyTypes', label: 'Legacy Types', subKeys: ['updateLegacyType', 'deleteLegacyType'] },
    { key: 'missionMetricGradationTypes', label: 'MissionMetricGradation Types', subKeys: ['updateMissionMetricGradationType', 'deleteMissionMetricGradationType'] },
    { key: 'missionMetricUoMTypes', label: 'MissionMetricUoM Types', subKeys: ['updateMissionMetricUoMType', 'deleteMissionMetricUoMType'] },
    
    { key: 'organizationTypes', label: 'Organization Types', subKeys: ['updateOrganizationType', 'deleteOrganizationType'] },
    
    { key: 'problemAreaTypes', label: 'ProblemArea Types', subKeys: ['updateProblemAreaType', 'deleteProblemAreaType'] },
    { key: 'problemMetricGradationTypes', label: 'ProblemMetricGradation Types', subKeys: ['updateProblemMetricGradationType', 'deleteProblemMetricGradationType'] },
    { key: 'problemMetricTypes', label: 'ProblemMetric Types', subKeys: ['updateProblemMetricType', 'deleteProblemMetricType'] },
    { key: 'problemMetricUoMTypes', label: 'ProblemMetricUoM Types', subKeys: ['updateProblemMetricUoMType', 'deleteProblemMetricUoMType'] },
    
    { key: 'sessionTypes', label: 'Session Types', subKeys: ['updateSessionType', 'deleteSessionType'] },
    { key: 'showcaseTypes', label: 'Showcase Types', subKeys: ['updateShowcaseType', 'deleteShowcaseType'] },
    
    
    { key: 'userChallengeTypes', label: 'UserChallenge Types', subKeys: ['updateUserChallengeType', 'deleteUserChallengeType'] },
    { key: 'winTypes', label: 'Win Types', subKeys: ['updateWinType', 'deleteWinType'] },
];

const orgAdminMenuItems = [
    { key: 'contactOrganizations', label: 'Contact Organizations', subKeys: ['updateContactOrganization', 'deleteContactOrganization'] },
    { key: 'orgUsers', label: 'Org Users', subKeys: ['updateOrgUser', 'deleteOrgUser'] },
    // { key: 'contacts', label: 'Contacts', subKeys: ['updateContact', 'deleteContact'] },

    // 27 Apr 2026
    { key: 'organizationBUs', label: 'Organization BUs', subKeys: ['updateOrganizationBU', 'deleteOrganizationBU'] },
    { key: 'accounts', label: 'Accounts', subKeys: ['updateAccount', 'deleteAccount'] },
    { key: "accountContactMaps", label: "Account Contact Maps",subKeys: ["updateAccountContactMap", "deleteAccountContactMap"],},
]

// 26 Jun 2026

const orgLeaderAdminMenuItems = [
    { key: 'contactOrganizations', label: 'Contact Organizations', subKeys: ['updateContactOrganization', 'deleteContactOrganization'] },
]


const userAdminMenuItems = [
    { key: 'contacts', label: 'Contacts', subKeys: ['updateContact', 'deleteContact'] },
]

const userAdminImprintMenuItems = [
    { key: 'userImprintEts', label: 'User 360 Imprint - Et', subKeys: ['updateUserImprintEt', 'deleteUserImprintEt'] },
]

// 08 Sep 2026

const orgIgniterMenuItems = [

    {
        key:
            'orgIgniterIntentionBoards',

        label:
            'Intention Boards',

        subKeys: [
            'viewOrgIgniterIntentionBoard',
        ],
    },

]

export {
    adminMenuItems,
    orgAdminMenuItems,
    userAdminMenuItems,
    userAdminImprintMenuItems,
    orgLeaderAdminMenuItems,        // 26 Jun 2026
    orgIgniterMenuItems,            // 08 Sep 2026
}

// export default adminMenuItems // Commented - 06 May 2025